import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgIdentityFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 10a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1Zm-4.535 8H4.535C5.818 16.171 7.79 15 10 15c2.21 0 4.182 1.171 5.465 3ZM20 13a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1ZM4 20a2.004 2.004 0 0 1-.595-.09A2 2 0 0 1 2 18V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4Zm9-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z", fill: color }));
};
export default factorySvgIcon(SvgIdentityFilled);
//# sourceMappingURL=SvgIdentityFilled.js.map